
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35706",
  depVersions: {
  "documents-public-ui": "static-1.35706",
  "atom": "static-1.5614",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.3028",
  "client-types": "static-1.524",
  "cssUtils": "static-1.1163",
  "customer-data-filters-ui": "static-1.41560",
  "customer-data-objects": "static-1.8255",
  "customer-data-property-utils": "static-1.8600",
  "documents-lib": "static-1.35711",
  "emoji-mart": "static-3.10",
  "flux-actions": "static-1.384",
  "FormsCommonComponents": "static-1.86956",
  "FormUrlGenerator": "static-2.5254",
  "foundations-theming-specialty": "static-1.2757",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5344",
  "highcharts": "static-8.118",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6131",
  "hs-test-utils": "static-1.8583",
  "hub-http": "static-1.6745",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12336",
  "HubStyleTokens": "static-2.12029",
  "I18n": "static-7.1725",
  "icons": "static-2.716",
  "jasmine-immutable": "static-1.3475",
  "jasmine-runner": "static-1.6998",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7689",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3416",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5915",
  "quartz": "static-1.7765",
  "react": "static-7.206",
  "react-dlb": "static-1.97",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17279",
  "react-select-plus": "static-1.121",
  "react-utils": "static-2.5719",
  "react-virtualized": "static-2.115",
  "reference-resolvers-lite": "static-1.8653",
  "reporting-data": "static-1.69652",
  "reporting-reports": "static-1.69328",
  "reporting-snowflake": "static-1.58268",
  "reporting-testing-lib": "static-1.11585",
  "reporting-visualizations": "static-1.61726",
  "reselect": "static-3.20",
  "sales-content-partitioning": "static-1.9498",
  "sanitize": "static-1.5008",
  "sanitize-text": "static-1.8697",
  "SharedI18nStrings": "static-1.191",
  "SharedLegalStrings": "static-1.2264",
  "signup-constants": "static-1.20123",
  "signup-ui-url-generator": "static-2.8576",
  "StyleGuideUI": "static-3.521",
  "superstore": "static-1.5295",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5292",
  "ui-addon-form-validation": "static-1.11353",
  "ui-asset-management-lib": "static-1.11651",
  "ui-images": "static-2.1296",
  "UIComponents": "static-3.8975",
  "usage-tracker": "static-1.7885",
  "usage-tracker-container": "static-1.7875",
  "usage-tracker-core": "static-1.7735",
  "viral-links-lib": "static-1.7624",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10176",
  "foundations-components": "static-1.8852",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.459",
  "quartz-config": "static-1.1543",
  "quartz-core": "static-1.6984",
  "quick-fetch": "static-1.4267",
  "raven": "static-3.6435",
  "redux": "static-4.81",
  "redux-thunk": "static-2.88",
  "rpc-client-utils": "static-1.5206",
  "ui-addon-i18n": "static-1.11688",
  "ui-addon-upgrades": "static-9.18611",
  "enviro": "static-4.529",
  "hs-promise-rejection-tracking": "static-1.6102",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.4042",
  "quartz-webpack": "static-1.3989",
  "foundations-assets": "static-1.5429",
  "foundations-theming": "static-1.5041",
  "hub-http-janus": "static-1.920",
  "hub-http-shared-msw-handlers": "static-1.11009",
  "hubspotter-http": "static-1.5013",
  "trellis-components": "static-1.3289",
  "trellis-migration-context": "static-1.119",
  "sassPrefix": "static-1.428",
  "conversations-skeleton-state": "static-1.7653",
  "crm-message-bus": "static-1.44261",
  "customer-data-filters-ui-msw-helpers": "static-1.23995",
  "customer-data-objects-ui-components": "static-1.13576",
  "customer-data-reference-ui-components": "static-1.13716",
  "customer-data-ui-utilities": "static-1.10373",
  "events-data-lib": "static-1.794",
  "framework-builder-read-service-client": "static-1.4374",
  "hs-resources": "static-1.736",
  "immer": "static-1.107",
  "inbound-db-meta-service-client": "static-1.3810",
  "inbound-db-properties-service-client": "static-1.4190",
  "multi-account-reference-resolvers": "static-1.1561",
  "onboarding-tours": "static-1.17486",
  "pulse": "static-1.1210",
  "reference-resolvers": "static-1.8726",
  "reporting-datasets-permissions-lib": "static-1.14879",
  "segments-client-types": "static-1.12400",
  "stylex": "static-1.49",
  "trellis-assets": "static-1.3270",
  "trellis-theming": "static-1.1585",
  "ui-addon-teams": "static-1.22079",
  "hs-browser-apis": "static-1.18",
  "quartz-auth": "static-1.1440",
  "ui-business-units-lib": "static-1.9636",
  "usage-tracker-session-replay": "static-1.5571",
  "ai-components-ui-library": "static-1.10136",
  "ContentUtils": "static-1.69625",
  "customer-data-properties": "static-1.53258",
  "forms-ai-lib": "static-1.5072",
  "forms-utils-lib": "static-1.13430",
  "foundations-components-test-utils": "static-1.6335",
  "react-dnd-compat": "static-1.5151",
  "react-tinymce": "static-1.56380",
  "tinymce-config": "static-2.55506",
  "ui-gdpr-components": "static-1.10659",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.4026",
  "HeadJS": "static-2.838",
  "framer-motion": "static-1.87",
  "hs-test-utils-bend-plugin": "static-1.3694",
  "msw": "static-1.106",
  "msw-config": "static-1.43",
  "testing-library": "static-1.168",
  "hs-locale-management": "static-1.442",
  "ui-fonts": "static-1.1291",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4845",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.242",
  "quartz-head": "static-1.1430",
  "web-vitals": "static-1.22",
  "batch-promise": "static-1.2092",
  "external-options-client-types": "static-1.4478",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1440",
  "frontend-preferences-client": "static-1.8463",
  "graphql": "static-1.96",
  "persist-promise": "static-1.4249",
  "reporting-client-types": "static-1.2903",
  "apollo-stack-hubspot": "static-3.102",
  "hubspot-apollo-client": "static-1.5416",
  "foundations-components-legacy": "static-1.1877",
  "quartz-routing": "static-1.1195",
  "hs-story-utils": "static-1.9965",
  "react-flip-move": "static-1.86",
  "nested-table": "static-1.762",
  "seat-types-lib": "static-1.1178",
  "timezone-utils": "static-2.5766",
  "react-create-root-preference": "static-1.123",
  "bend-plugin-foundations-components": "static-1.5121",
  "floating-ui": "static-1.71",
  "react-aria": "static-1.80",
  "tanstack-table": "static-1.69",
  "opentelemetry-fe-types": "static-1.340",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.620",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.715",
  "quartz-test": "static-1.1440",
  "quartz-tracking": "static-1.1144",
  "bend-plugin-chirp-manifest": "static-1.616",
  "chirp-fetch": "static-1.2440",
  "merchandise-lib": "static-1.291",
  "purchase-motions-components": "static-1.6724",
  "ts-schema": "static-1.4433",
  "bender-build-tools": "static-1.3648",
  "bend-plugin-foundations-theming": "static-1.3524",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5129",
  "conditional-properties-service-client": "static-1.4151",
  "crm-pipelines-api-client-types": "static-1.4484",
  "event-emitter": "static-1.1500",
  "fdsr-migration-layer": "static-1.554",
  "multi-currency-client-types": "static-1.4049",
  "getting-started-shared-tasks": "static-1.19669",
  "growth-data-modal": "static-1.6222",
  "growth-onboarding-confetti": "static-1.3596",
  "growth-onboarding-next-action-utils": "static-1.3105",
  "navigation-components": "static-1.19333",
  "nest": "static-1.780",
  "onboarding-tours-client": "static-1.5701",
  "onboarding-tours-utils": "static-1.1553",
  "ui-shepherd-react": "static-3.10828",
  "ui-shepherd-tracker": "static-1.8209",
  "ui-universal-auth": "static-1.9869",
  "user-context": "static-1.5598",
  "bend-plugin-pulse": "static-1.713",
  "fast-json-patch": "static-1.77",
  "crm-index-associations-lib": "static-1.6990",
  "stylex-utils": "static-1.192",
  "hubspotter-http-shared-msw-handlers": "static-1.11007",
  "magpie-lib": "static-1.5964",
  "navigation-messaging": "static-1.8660",
  "amplitude-session-replay-browser": "static-1.80",
  "chatspot-core": "static-1.24293",
  "copilot-toolkit": "static-1.12273",
  "cms-field-types": "static-1.5353",
  "content-icons-ui": "static-1.2524",
  "integrations-lib": "static-1.17567",
  "calling-global-api": "static-1.66528",
  "calling-internal-common": "static-1.31863",
  "calling-lifecycle-internal": "static-1.67910",
  "calling-lifecycle-messages": "static-1.60202",
  "commerce-products-lib": "static-1.11101",
  "crm-index-visualization-core": "static-1.4853",
  "crm-links": "static-1.6868",
  "customer-data-properties-shared-msw-handlers": "static-1.10336",
  "data-agent-utils": "static-1.1070",
  "data-token-picker": "static-1.17228",
  "file-manager-components": "static-1.24942",
  "formula-editor": "static-1.15087",
  "google-libphonenumber": "static-1.53",
  "inbounddb-objects-service-types": "static-1.4555",
  "meetings-icalendar-utils-lib": "static-1.1175",
  "object-builder-ui-client": "static-1.50227",
  "pipeline-validation-client-types": "static-1.4322",
  "property-value-citations": "static-1.3872",
  "react-colorpicker": "static-2.10749",
  "rich-text-lib": "static-1.20650",
  "smart-data-capture-core": "static-1.622",
  "tiered-pricing": "static-1.2392",
  "tinymce-plugins": "static-1.58620",
  "tinymce-themes": "static-1.57476",
  "topics-actions-lib": "static-1.734",
  "trellis-ext-i18n": "static-1.1484",
  "trial-components-library": "static-1.14487",
  "ui-addon-emoji-picker": "static-1.10404",
  "ui-addon-iframeable": "static-1.9620",
  "zustand": "static-1.93",
  "final-form": "static-1.86",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.85",
  "hub-http-contrib": "static-1.3570",
  "interframe": "static-3.5285",
  "tinymce-data": "static-1.41591",
  "ui-addon-sales-email": "static-1.5748",
  "hubspot-apollo-cache": "static-1.875",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.695",
  "opentelemetry-web": "static-1.26",
  "onboarding-scopes": "static-1.6992",
  "purchase-motions-api": "static-1.6727",
  "onboarding-data-sync-lib": "static-1.2926",
  "growth-onboarding-next-action-components": "static-1.3133",
  "user-context-client": "static-1.5047",
  "idb-keyval": "static-1.58",
  "magpie-types": "static-1.5424",
  "reactive-lib": "static-1.1262",
  "simple-logging-lib": "static-1.3587",
  "custom-vendor-connection-lib": "static-1.433",
  "unified-auth-core-lib": "static-1.1665",
  "getting-started-shared-tasks-store": "static-1.18787",
  "nav-meta": "static-1.30970",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2395",
  "integrations-error-boundary-lib": "static-1.14982",
  "integrations-tracking-lib": "static-1.6169",
  "native-integrations-shared-strings": "static-1.8298",
  "redux-observable": "static-1.82",
  "ReduxMessenger": "static-2.10912",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31870",
  "shared-worker-versioning": "static-1.11580",
  "calling-usage-tracker": "static-1.7081",
  "customer-data-tracking": "static-1.7411",
  "voice-sms-access-library": "static-1.2619",
  "commerce-permissions": "static-1.1323",
  "growth-payments-core": "static-1.26634",
  "products-iframe-lib": "static-1.9062",
  "products-ui-components-shared-msw-handlers": "static-1.11391",
  "sales-views-client-types": "static-1.4798",
  "location-customization-utils-lib": "static-1.10565",
  "data-agent-kit": "static-1.1057",
  "enrichment-settings-lib": "static-1.417",
  "fsm": "static-1.4301",
  "policy-lib": "static-1.7344",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4685",
  "poll-commands": "static-1.4017",
  "video-components-external": "static-1.12558",
  "video-data-lib": "static-1.36216",
  "bark-lib": "static-1.17075",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.109",
  "crm-properties-common-lib": "static-1.6437",
  "react-codemirror": "static-1.11182",
  "upgrade-components-lib": "static-1.798",
  "FileManagerLib": "static-1.40582",
  "content-assistance-lib": "static-1.8508",
  "FileManagerCore": "static-1.40441",
  "layout-dnd-components": "static-1.13323",
  "layout-dnd-utils": "static-1.12298",
  "ui-brand-identity-lib": "static-1.17106",
  "NamespacedHubStyle": "static-2.9408",
  "embedded-academy-lib": "static-1.16222",
  "hubs-service-types": "static-1.1807",
  "nudge-client-utils": "static-1.3517",
  "salesImages": "static-1.798",
  "InboxConnectUtils": "static-4.15962",
  "meetings-connect-utils-lib": "static-1.8159",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1373",
  "breeze-engine-core": "static-1.1673",
  "highlight.js": "static-1.93",
  "universal-page-editor-lib": "static-1.3560",
  "calling-orchestration-schema": "static-1.37396",
  "ui-addon-opt": "static-4.8977",
  "crm-record-cards-service-types": "static-1.3896",
  "trellis-story-utils": "static-1.5036",
  "storybook-react": "static-1.47",
  "content-media-composition-data-lib": "static-1.13698",
  "content-media-compositions": "static-2.17705",
  "media-bridge-lib": "static-1.19734",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16778",
  "browser-eslint": "static-2.57",
  "audio-components": "static-1.6654",
  "FileManagerImages": "static-1.38093",
  "video-components": "static-1.14560",
  "ui-addon-video-player": "static-1.9162",
  "ui-coaching-tips": "static-1.29644",
  "breeze-artifacts-sdk": "static-1.1224",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30153",
  "html-to-image": "static-1.68",
  "urlinator": "static-1.5058",
  "video-embed": "static-1.37050",
  "ContentData": "static-1.69700",
  "layout-data-lib": "static-1.10623",
  "academy-common-lib": "static-1.15683",
  "nudge-custom-function-registry": "static-1.3274",
  "nudge-renderer-utils": "static-1.3593",
  "whisper-core-api": "static-1.7746",
  "crm-record-cards-client": "static-1.238",
  "framework-data-schema-resolvers": "static-1.7432",
  "social-insights-client-types": "static-1.23050",
  "growth-onboarding-feedback-components": "static-1.7125",
  "outpost": "static-1.4665",
  "advanced-menus-core": "static-1.15914",
  "advanced-menus-lib": "static-1.12642",
  "ExportDialog": "static-6.10914",
  "ui-memberships-settings-lib": "static-1.35336",
  "academy-service-client": "static-1.4234",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4935",
  "trellis-ecosystem": "static-1.7942",
  "ui-addon-react-router-dom": "static-1.10068",
  "framework-data-schema-quick-fetch": "static-1.7337",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15913",
  "simple-menus-lib": "static-1.17430",
  "settings-ui-lib": "static-1.13072",
  "marketplace-ui-apps-core": "static-1.19695",
  "marketplace-ui-common": "static-1.21163",
  "developer-experience-shared-components": "static-1.11085",
  "immutable-less": "static-1.5188",
  "marketplace-ui-client-types": "static-1.18570",
  "ui-addon-integrations-directory-panel": "static-2.8490",
  "ui-extensibility-client-types": "static-1.4458",
  "ai-settings-ui-library": "static-1.8691",
  "ui-product-approvals-common": "static-1.1818",
  "apps-service-types": "static-1.4148",
  "oauth-service-types": "static-1.4676",
  "simple-data-table": "static-1.3946"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35706",
  "atom": "/atom/static-1.5614",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.3028",
  "client-types": "/client-types/static-1.524",
  "cssUtils": "/cssUtils/static-1.1163",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41560",
  "customer-data-objects": "/customer-data-objects/static-1.8255",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8600",
  "documents-lib": "/documents-lib/static-1.35711",
  "emoji-mart": "/emoji-mart/static-3.10",
  "flux-actions": "/flux-actions/static-1.384",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86956",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5254",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2757",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5344",
  "highcharts": "/highcharts/static-8.118",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6131",
  "hs-test-utils": "/hs-test-utils/static-1.8583",
  "hub-http": "/hub-http/static-1.6745",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12336",
  "HubStyleTokens": "/HubStyleTokens/static-2.12029",
  "I18n": "/I18n/static-7.1725",
  "icons": "/icons/static-2.716",
  "jasmine-immutable": "/jasmine-immutable/static-1.3475",
  "jasmine-runner": "/jasmine-runner/static-1.6998",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7689",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3416",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5915",
  "quartz": "/quartz/static-1.7765",
  "react": "/react/static-7.206",
  "react-dlb": "/react-dlb/static-1.97",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17279",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-utils": "/react-utils/static-2.5719",
  "react-virtualized": "/react-virtualized/static-2.115",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8653",
  "reporting-data": "/reporting-data/static-1.69652",
  "reporting-reports": "/reporting-reports/static-1.69328",
  "reporting-snowflake": "/reporting-snowflake/static-1.58268",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11585",
  "reporting-visualizations": "/reporting-visualizations/static-1.61726",
  "reselect": "/reselect/static-3.20",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9498",
  "sanitize": "/sanitize/static-1.5008",
  "sanitize-text": "/sanitize-text/static-1.8697",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2264",
  "signup-constants": "/signup-constants/static-1.20123",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8576",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "superstore": "/superstore/static-1.5295",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5292",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11353",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11651",
  "ui-images": "/ui-images/static-2.1296",
  "UIComponents": "/UIComponents/static-3.8975",
  "usage-tracker": "/usage-tracker/static-1.7885",
  "usage-tracker-container": "/usage-tracker-container/static-1.7875",
  "usage-tracker-core": "/usage-tracker-core/static-1.7735",
  "viral-links-lib": "/viral-links-lib/static-1.7624",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10176",
  "foundations-components": "/foundations-components/static-1.8852",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "quartz-config": "/quartz-config/static-1.1543",
  "quartz-core": "/quartz-core/static-1.6984",
  "quick-fetch": "/quick-fetch/static-1.4267",
  "raven": "/raven/static-3.6435",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.88",
  "rpc-client-utils": "/rpc-client-utils/static-1.5206",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11688",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18611",
  "enviro": "/enviro/static-4.529",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4042",
  "quartz-webpack": "/quartz-webpack/static-1.3989",
  "foundations-assets": "/foundations-assets/static-1.5429",
  "foundations-theming": "/foundations-theming/static-1.5041",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11009",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "trellis-components": "/trellis-components/static-1.3289",
  "trellis-migration-context": "/trellis-migration-context/static-1.119",
  "sassPrefix": "/sassPrefix/static-1.428",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7653",
  "crm-message-bus": "/crm-message-bus/static-1.44261",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23995",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13576",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13716",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10373",
  "events-data-lib": "/events-data-lib/static-1.794",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "hs-resources": "/hs-resources/static-1.736",
  "immer": "/immer/static-1.107",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3810",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4190",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1561",
  "onboarding-tours": "/onboarding-tours/static-1.17486",
  "pulse": "/pulse/static-1.1210",
  "reference-resolvers": "/reference-resolvers/static-1.8726",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14879",
  "segments-client-types": "/segments-client-types/static-1.12400",
  "stylex": "/stylex/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.3270",
  "trellis-theming": "/trellis-theming/static-1.1585",
  "ui-addon-teams": "/ui-addon-teams/static-1.22079",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.1440",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9636",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5571",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10136",
  "ContentUtils": "/ContentUtils/static-1.69625",
  "customer-data-properties": "/customer-data-properties/static-1.53258",
  "forms-ai-lib": "/forms-ai-lib/static-1.5072",
  "forms-utils-lib": "/forms-utils-lib/static-1.13430",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6335",
  "react-dnd-compat": "/react-dnd-compat/static-1.5151",
  "react-tinymce": "/react-tinymce/static-1.56380",
  "tinymce-config": "/tinymce-config/static-2.55506",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10659",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.4026",
  "HeadJS": "/HeadJS/static-2.838",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3694",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.43",
  "testing-library": "/testing-library/static-1.168",
  "hs-locale-management": "/hs-locale-management/static-1.442",
  "ui-fonts": "/ui-fonts/static-1.1291",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4845",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.242",
  "quartz-head": "/quartz-head/static-1.1430",
  "web-vitals": "/web-vitals/static-1.22",
  "batch-promise": "/batch-promise/static-1.2092",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1440",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8463",
  "graphql": "/graphql/static-1.96",
  "persist-promise": "/persist-promise/static-1.4249",
  "reporting-client-types": "/reporting-client-types/static-1.2903",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.102",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5416",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1877",
  "quartz-routing": "/quartz-routing/static-1.1195",
  "hs-story-utils": "/hs-story-utils/static-1.9965",
  "react-flip-move": "/react-flip-move/static-1.86",
  "nested-table": "/nested-table/static-1.762",
  "seat-types-lib": "/seat-types-lib/static-1.1178",
  "timezone-utils": "/timezone-utils/static-2.5766",
  "react-create-root-preference": "/react-create-root-preference/static-1.123",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5121",
  "floating-ui": "/floating-ui/static-1.71",
  "react-aria": "/react-aria/static-1.80",
  "tanstack-table": "/tanstack-table/static-1.69",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.340",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.620",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.715",
  "quartz-test": "/quartz-test/static-1.1440",
  "quartz-tracking": "/quartz-tracking/static-1.1144",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.616",
  "chirp-fetch": "/chirp-fetch/static-1.2440",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "purchase-motions-components": "/purchase-motions-components/static-1.6724",
  "ts-schema": "/ts-schema/static-1.4433",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3524",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5129",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4151",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4484",
  "event-emitter": "/event-emitter/static-1.1500",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.554",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4049",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19669",
  "growth-data-modal": "/growth-data-modal/static-1.6222",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3596",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3105",
  "navigation-components": "/navigation-components/static-1.19333",
  "nest": "/nest/static-1.780",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5701",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1553",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10828",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8209",
  "ui-universal-auth": "/ui-universal-auth/static-1.9869",
  "user-context": "/user-context/static-1.5598",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.713",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6990",
  "stylex-utils": "/stylex-utils/static-1.192",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11007",
  "magpie-lib": "/magpie-lib/static-1.5964",
  "navigation-messaging": "/navigation-messaging/static-1.8660",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "chatspot-core": "/chatspot-core/static-1.24293",
  "copilot-toolkit": "/copilot-toolkit/static-1.12273",
  "cms-field-types": "/cms-field-types/static-1.5353",
  "content-icons-ui": "/content-icons-ui/static-1.2524",
  "integrations-lib": "/integrations-lib/static-1.17567",
  "calling-global-api": "/calling-global-api/static-1.66528",
  "calling-internal-common": "/calling-internal-common/static-1.31863",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67910",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60202",
  "commerce-products-lib": "/commerce-products-lib/static-1.11101",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4853",
  "crm-links": "/crm-links/static-1.6868",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10336",
  "data-agent-utils": "/data-agent-utils/static-1.1070",
  "data-token-picker": "/data-token-picker/static-1.17228",
  "file-manager-components": "/file-manager-components/static-1.24942",
  "formula-editor": "/formula-editor/static-1.15087",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4555",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1175",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50227",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4322",
  "property-value-citations": "/property-value-citations/static-1.3872",
  "react-colorpicker": "/react-colorpicker/static-2.10749",
  "rich-text-lib": "/rich-text-lib/static-1.20650",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.622",
  "tiered-pricing": "/tiered-pricing/static-1.2392",
  "tinymce-plugins": "/tinymce-plugins/static-1.58620",
  "tinymce-themes": "/tinymce-themes/static-1.57476",
  "topics-actions-lib": "/topics-actions-lib/static-1.734",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1484",
  "trial-components-library": "/trial-components-library/static-1.14487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10404",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9620",
  "zustand": "/zustand/static-1.93",
  "final-form": "/final-form/static-1.86",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "hub-http-contrib": "/hub-http-contrib/static-1.3570",
  "interframe": "/interframe/static-3.5285",
  "tinymce-data": "/tinymce-data/static-1.41591",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5748",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.875",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.695",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "onboarding-scopes": "/onboarding-scopes/static-1.6992",
  "purchase-motions-api": "/purchase-motions-api/static-1.6727",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2926",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3133",
  "user-context-client": "/user-context-client/static-1.5047",
  "idb-keyval": "/idb-keyval/static-1.58",
  "magpie-types": "/magpie-types/static-1.5424",
  "reactive-lib": "/reactive-lib/static-1.1262",
  "simple-logging-lib": "/simple-logging-lib/static-1.3587",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.433",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1665",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18787",
  "nav-meta": "/nav-meta/static-1.30970",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2395",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14982",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6169",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8298",
  "redux-observable": "/redux-observable/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10912",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31870",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11580",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7081",
  "customer-data-tracking": "/customer-data-tracking/static-1.7411",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2619",
  "commerce-permissions": "/commerce-permissions/static-1.1323",
  "growth-payments-core": "/growth-payments-core/static-1.26634",
  "products-iframe-lib": "/products-iframe-lib/static-1.9062",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11391",
  "sales-views-client-types": "/sales-views-client-types/static-1.4798",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10565",
  "data-agent-kit": "/data-agent-kit/static-1.1057",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.417",
  "fsm": "/fsm/static-1.4301",
  "policy-lib": "/policy-lib/static-1.7344",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4685",
  "poll-commands": "/poll-commands/static-1.4017",
  "video-components-external": "/video-components-external/static-1.12558",
  "video-data-lib": "/video-data-lib/static-1.36216",
  "bark-lib": "/bark-lib/static-1.17075",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.109",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6437",
  "react-codemirror": "/react-codemirror/static-1.11182",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.798",
  "FileManagerLib": "/FileManagerLib/static-1.40582",
  "content-assistance-lib": "/content-assistance-lib/static-1.8508",
  "FileManagerCore": "/FileManagerCore/static-1.40441",
  "layout-dnd-components": "/layout-dnd-components/static-1.13323",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12298",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17106",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9408",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16222",
  "hubs-service-types": "/hubs-service-types/static-1.1807",
  "nudge-client-utils": "/nudge-client-utils/static-1.3517",
  "salesImages": "/salesImages/static-1.798",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15962",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8159",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1373",
  "breeze-engine-core": "/breeze-engine-core/static-1.1673",
  "highlight.js": "/highlight.js/static-1.93",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3560",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37396",
  "ui-addon-opt": "/ui-addon-opt/static-4.8977",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3896",
  "trellis-story-utils": "/trellis-story-utils/static-1.5036",
  "storybook-react": "/storybook-react/static-1.47",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13698",
  "content-media-compositions": "/content-media-compositions/static-2.17705",
  "media-bridge-lib": "/media-bridge-lib/static-1.19734",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16778",
  "browser-eslint": "/browser-eslint/static-2.57",
  "audio-components": "/audio-components/static-1.6654",
  "FileManagerImages": "/FileManagerImages/static-1.38093",
  "video-components": "/video-components/static-1.14560",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9162",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29644",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1224",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30153",
  "html-to-image": "/html-to-image/static-1.68",
  "urlinator": "/urlinator/static-1.5058",
  "video-embed": "/video-embed/static-1.37050",
  "ContentData": "/ContentData/static-1.69700",
  "layout-data-lib": "/layout-data-lib/static-1.10623",
  "academy-common-lib": "/academy-common-lib/static-1.15683",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3274",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3593",
  "whisper-core-api": "/whisper-core-api/static-1.7746",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.238",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "social-insights-client-types": "/social-insights-client-types/static-1.23050",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7125",
  "outpost": "/outpost/static-1.4665",
  "advanced-menus-core": "/advanced-menus-core/static-1.15914",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12642",
  "ExportDialog": "/ExportDialog/static-6.10914",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35336",
  "academy-service-client": "/academy-service-client/static-1.4234",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4935",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7942",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10068",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15913",
  "simple-menus-lib": "/simple-menus-lib/static-1.17430",
  "settings-ui-lib": "/settings-ui-lib/static-1.13072",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19695",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21163",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11085",
  "immutable-less": "/immutable-less/static-1.5188",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18570",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8490",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4458",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8691",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1818",
  "apps-service-types": "/apps-service-types/static-1.4148",
  "oauth-service-types": "/oauth-service-types/static-1.4676",
  "simple-data-table": "/simple-data-table/static-1.3946"
}
};
